import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import BigNumber from "../../atoms/BigNumber";
import NewsHeadline from "../../atoms/NewsHeadline";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { getSlotId } from "../../utils/utils";

import "./tenNumberedStories.m.css";

const TenNumberedStories = ({ collection }) => {
  if (!collection?.items?.length) return null;

  const { items = [], "associated-metadata": { ad_slot: adSlot } = {} } = collection;

  const stories = items.reduce((accumulator, item) => {
    if (item.type === "story") {
      accumulator.push(item.story);
    }
    return accumulator;
  }, []);

  if (!stories.length) return null;

  return (
    <ComponentContainer collection={collection}>
      <div styleName={adSlot ? "has-ad" : ""}>
        <div styleName="grid-wrapper">
          {stories.map((story, index) => (
            <div styleName="number-headline" key={index} style={{ "--row-num": index + 1 }}>
              <div styleName="number-wrapper">
                <BigNumber styleName="number" headlineNumber={index + 1} />
              </div>
              <NewsHeadline story={story} showSponsor={false} iconEnd={true} />
            </div>
          ))}

          {adSlot && (
            <DfpContainer styleName="ad-wrapper">
              <div className="adsBox">
                <DfpComponent
                  type={adSlot}
                  collectionSlug={collection.slug}
                  slotId={getSlotId(adSlot, collection.slug, "ten-numbered-stories")}
                  layoutName="TenNumberedStories"
                />
              </div>
            </DfpContainer>
          )}
        </div>
      </div>
    </ComponentContainer>
  );
};

TenNumberedStories.storyLimit = 10;

TenNumberedStories.propTypes = {
  collection: object.isRequired,
};

export default TenNumberedStories;
